import { subtitleCopy } from "../../iris/maker-language";
import type { SubtitleScreen } from "../subtitle-view";
import "./subtitles.css";

/** The fading tail of three lines, and Iris's latest line as the subtitle. One live region stays in place, so screen
 * readers announce each new line (a region that arrives already filled is often not read). */
export function SubtitleStage({ screen, reveal, thinking = false }: {
  screen: SubtitleScreen;
  reveal: { index: number; words: number } | null;
  thinking?: boolean;
}) {
  const copy = subtitleCopy();
  const current = screen.current;
  // With the directions on the board, the line says so: Iris's intro ("Here's one direction…") stays in Read back.
  const text = current ? (screen.ideasOnBoard ? copy.ideasOnBoard : current.text) : "";
  const revealing = !!current && !screen.ideasOnBoard && reveal?.index === current.index;
  return (
    <div className="subtitle-stage">
      <ol className="subtitle-tail">
        {screen.tail.map((line, position) => (
          <li key={line.index} className={`subtitle-tail-line ${line.role} ${line.kind}`} data-age={screen.tail.length - position}>
            {line.role === "maker" ? `— ${copy.you}: ${line.text}` : line.text}
          </li>
        ))}
      </ol>
      <div className="subtitle-live" aria-live="polite">
        {current ? (
          <p key={current.index} className={`subtitle-line ${current.size}${current.error ? " error" : ""}`}>
            {revealing && reveal!.words === 0 ? (
              // Her voice is on its way: the line is visibly coming, never blank.
              <span className="talk-dots" aria-hidden="true"><i /><i /><i /></span>
            ) : revealing ? (
              text.split(/(?<=\s)/).slice(0, reveal!.words).join("")
            ) : (
              text
            )}
          </p>
        ) : (
          thinking && <span className="sr-only">Iris is thinking</span>
        )}
      </div>
    </div>
  );
}
